
import store from '@/store'
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

export function dateFormat(cellValue, type = 1) {
  if (cellValue !== null && cellValue !== '') {
    const dates = new Date(cellValue)
    const year = dates.getFullYear()
    const month = dates.getMonth() + 1
    const date = dates.getDate()
    if (type === 1) {
      // const day = dates.getDay()
      const hour = dates.getHours()
      const min = dates.getMinutes()
      const ss = dates.getSeconds();
      +' ' + strFormat(hour) + ':' + strFormat(min) + ':' + strFormat(ss)

      const timeFormat = year + '-' + strFormat(month) + '-' + strFormat(date) + ' ' + strFormat(hour) + ':' + strFormat(min) + ':' + strFormat(ss)
      return timeFormat
    } else if (type === 2) {
      // const timeFormat = year + '-' + strFormat(month) + '-' + strFormat(date)
      return year
    } else {
      const timeFormat = year + '-' + strFormat(month) + '-' + strFormat(date)
      return timeFormat
    }
  }
  return ''
}
// 字符串拼接
function strFormat(str) {
  return str < 10 ? `0${str}` : str
}
export function getButtonsIsPower(code) {
  const buttons = store.getters.buttons
  var btnRouter = buttons.find((item, index) => {
    return item.code === code
  })
  if (btnRouter) {
    return true
  } else {
    this.$message({
      message: '您没有该操作权限',
      type: 'warning'
    })
    return false
  }
}
export function getButtonsPower(code) {
  const buttons = store.getters.buttons
  var btnRouter = buttons.find((item, index) => {
    return item.code === code
  })
  if (!btnRouter) {
    this.$message({
      message: '您没有该操作权限',
      type: 'warning'
    })
  }
  return btnRouter
}
